import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';

import { Disclosure } from '~shared/components/Disclosure';
import ImagePreviewer from '~shared/components/ImageField/ImagePreviewer';
import { RichTextRenderer } from '~shared/components/RichTextRenderer';
import { Stack } from '~shared/components/Stack';

import { useResultQuestionState } from '../ActivityResult/ActivityResultQuestionProvider';

export function ResultsQuestionExplanation(): React.ReactElement {
  const questionContext = useResultQuestionState();
  const { question: { questionId, type, explanation, explanationImage } = {} } =
    questionContext;
  const [showExplanation, setShowExplanation] = React.useState(false);
  const hasExplanation = explanation || explanationImage;
  const containerClass = cx(
    'grid grid-cols-question-fields max-w-5xl p-0 pt-11',
    type === 'MC' && 'pl-4 lg:pl-0'
  );

  return (
    <div className={containerClass}>
      <div className="flex items-center justify-center w-9 h-12">
        <div
          className="flex flex-none items-center justify-center w-9 h-9 bg-white rounded-round text-grey-300 select-none pointer-events-none shadow-inner-outline"
          aria-hidden={true}
        >
          <div className="relative top-px font-display font-700 text-blue-600 text-base">
            i
          </div>
        </div>
      </div>
      <div className="flex items-center">
        {hasExplanation ? (
          <Disclosure
            key={questionId}
            id="explanation-toggle"
            expanded={showExplanation}
            expandLabel={translate('Show explanation')}
            collapseLabel={translate('Hide explanation')}
            onToggle={setShowExplanation}
          >
            <Stack space="2">
              {explanation ? (
                <RichTextRenderer
                  className="font-sans text-blue-900 text-base leading-8"
                  htmlText={explanation}
                />
              ) : null}
              {explanationImage ? (
                <ImagePreviewer
                  imageURL={explanationImage.urlS}
                  imageStyle="max-h-64 rounded-1"
                  showOutline
                  containerStyle="inline-flex my-2 rounded-1"
                  allowZoom
                  zoomImageURL={explanationImage.url}
                />
              ) : null}
            </Stack>
          </Disclosure>
        ) : (
          <span className="font-display text-display font-500 leading-8 text-blue-900">
            {translate('No Explanation')}
          </span>
        )}
      </div>
    </div>
  );
}
